import React from 'react';
import { getHouseTypeButtonText } from '../../utils/formOptions';
import { buildHouseTypeOptions } from '../../utils/houseTypeOptionsUtils';

function HouseTypeDropdown({
  houseTypeData,
  selectedHouseTypes,
  onHouseTypeChange,
  isOpen,
  onToggle,
  disabled = false,
}) {
  const houseTypeOptions = buildHouseTypeOptions(houseTypeData);
  const getButtonText = () => getHouseTypeButtonText(selectedHouseTypes);

  return (
    <fieldset className="md:border-l-2 bg-white h-15 border-[#ebebeb] lg:h-full md:bg-none flex items-center justify-center relative">
      <legend className="sr-only">House type</legend>
      <button
        type="button"
        className="text-sm font-medium flex items-center gap-3 lg:h-15"
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        {getButtonText()}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          aria-hidden="true"
          focusable="false"
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s',
          }}
        >
          <use href="#icon-chevron-down" />
        </svg>
      </button>
      {isOpen && (
        <div className="z-50 absolute w-full xl:w-[calc(100%+4px)] bg-white top-full -left-[2px] p-4 border-2 border-[#ebebeb]">
          <div>
            <h4 className="font-light text-xs mb-3">Property type</h4>
            <div className="space-y-3">
              {houseTypeOptions.map(({ value, label }) => (
                <label key={value} className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    checked={selectedHouseTypes.includes(value)}
                    onChange={
                      disabled ? undefined : () => onHouseTypeChange(value)
                    }
                    className="w-4 h-4"
                    disabled={disabled}
                  />
                  <span
                    className={`text-sm font-light ${
                      disabled ? 'opacity-50' : ''
                    }`}
                  >
                    {label}
                  </span>
                </label>
              ))}
            </div>
          </div>
        </div>
      )}
    </fieldset>
  );
}

export default HouseTypeDropdown;
